export default {
  footerLegalText: "{{year, year}} جميع الحقوق محفوظة - فانوس  ©",
  goToDashboard: "انتقل إلى الصفحة الرئيسية",
  invalidCode: "!رمز التحقق غير صحيح",
};
